import { AvailableVariableTypes } from 'components/domain/customData/useTemplateVariables';

export const CUSTOM_TEMPLATE_VARIABLE_TYPES: AvailableVariableTypes[] = [
  'lead',
  'guest',
  'order',
  'agency',
  'property',
  'message',
  'custom',
];
